export interface ProductSpec {
  material: string;
  finish: string;
  weight: string;
}

export interface ProductItem {
  id: string;
  numberStr: string;
  category: string;
  year: string;
  titleBold: string;
  titleOutline: string;
  description: string;
  imageSrc: string;
  imageAlt: string;
  specs: ProductSpec;
}

export const productsData: ProductItem[] = [
  {
    id: "prod-1",
    numberStr: "01",
    category: "FURNITURE",
    year: "2026",
    titleBold: "TABLE",
    titleOutline: "COLLECTION",
    description:
      "Premium handcrafted coffee tables, dining tables, console tables, side tables, and center tables designed for luxury interiors.",
    imageSrc: "/product/cofeetablev2.webp",
    imageAlt: "Luxury handcrafted table collection",
    specs: {
      material: "Wood • Metal • Marble • Glass",
      finish: "Custom Size & Finish",
      weight: "Residential • Hospitality"
    }
  },
  {
    id: "prod-2",
    numberStr: "02",
    category: "HOME DÉCOR",
    year: "2026",
    titleBold: "HOME",
    titleOutline: "DÉCOR",
    description:
      "Luxury candle holders, vases, sculptures, trays, and decorative accessories handcrafted for modern interiors.",
    imageSrc: "/product/home-decor21.webp",
    imageAlt: "Premium home décor",
    specs: {
      material: "Brass • Iron • Aluminum • Resin",
      finish: "Antique • Matte • Polished",
      weight: "Retail • Hotels"
    }
  },
  {
    id: "prod-3",
    numberStr: "03",
    category: "OUTDOOR",
    year: "2026",
    titleBold: "GARDEN",
    titleOutline: "COLLECTION",
    description:
      "Garden planters, fountains, sculptures, and lanterns crafted for premium outdoor spaces.",
    imageSrc: "/product/garden-decor11.webp",
    imageAlt: "Luxury garden collection",
    specs: {
      material: "Stone • Iron • Aluminum",
      finish: "Weather Resistant",
      weight: "Landscape • Resort"
    }
  },

  {
    id: "prod-4",
    numberStr: "04",
    category: "KITCHEN",
    year: "2026",
    titleBold: "KITCHEN",
    titleOutline: "ESSENTIALS",
    description:
      "Cookware, serveware, cutlery, and storage products designed for premium kitchens worldwide.",
    imageSrc: "/product/kitchenv11.webp",
    imageAlt: "Kitchenware collection",
    specs: {
      material: "Stainless Steel • Brass • Copper",
      finish: "Food Grade Finish",
      weight: "OEM • Private Label"
    }
  },
  {
    id: "prod-5",
    numberStr: "05",
    category: "BATHROOM",
    year: "2026",
    titleBold: "BATHROOM",
    titleOutline: "ACCESSORIES",
    description:
      "Luxury bathroom accessories including towel racks, soap dispensers, shelves, and organizers.",
    imageSrc: "/product/bathroomv2.webp",
    imageAlt: "Bathroom accessories",
    specs: {
      material: "Stainless Steel • Brass",
      finish: "Chrome • Matte Black • Gold",
      weight: "Residential • Hotel"
    }
  }
];